<div class="container-fluid">
    <mat-toolbar class="toolbar-bg-blue">
        <h2>Create User</h2>
        <div class="forModalClose">
            <span (click)="cancel()">X</span>
        </div>

    </mat-toolbar>
    <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="isShowAlert">
        <b> User {{btnText}}d successfully.</b>
        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <form [formGroup]="userForm" #myForm="ngForm" (ngSubmit)="userFormSubmit()">

        <mat-form-field>
            <mat-label>Name</mat-label>
            <input type="text" formControlName="name" matInput>
            <mat-error *ngIf="userFormValidate?.name?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Email ID</mat-label>
            <input type="email" formControlName="email" matInput>
            <mat-error *ngIf="userFormValidate?.email?.errors?.required">This field is required.</mat-error>
            <mat-error *ngIf="userFormValidate?.email?.errors?.email">Please enter a valid email address.</mat-error>
            <mat-error *ngIf="userFormValidate?.email?.errors?.serverError"> {{userFormValidate?.email?.errors?.serverError}}</mat-error>
        </mat-form-field>

        <!-- <mat-form-field>
            <mat-label>Timezone</mat-label>
            <mat-select formControlName="timezone">
                <mat-option *ngFor="let timezone of  timezones;" [value]="timezone">{{timezone}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFormValidate?.timezone?.errors?.required">This field is required.</mat-error>
        </mat-form-field> -->

        <mat-form-field>
            <mat-label>Timezone</mat-label>
            <input type="hidden" formControlName="timezone">
            <input matInput placeholder="Search" [matAutocomplete]="auto" [formControl]="searchTimezoneCtrl">
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let timezone of filterTimezones | async;" [value]="timezone">
                    <span>{{timezone}}</span>
                </mat-option>
            </mat-autocomplete>
            <mat-error *ngIf="searchTimezoneCtrl?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>Roles</mat-label>
            <mat-select formControlName="role_id">
                <mat-option *ngFor="let role of roles;" [value]="role?.id">
                    <span>{{role?.name}}</span>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="userFormValidate?.role_id?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="isShowOrganization">
            <mat-label>Organizations</mat-label>
            <mat-select formControlName="org_id" (selectionChange)="organizationChange($event)">
                <mat-option *ngFor="let organization of organizations;" [value]="organization?.org_id">{{organization?.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="userFormValidate?.shift_week_starts?.errors?.required">This field is required.</mat-error>
        </mat-form-field>

        <!-- <mat-form-field>
            <mat-label>Reporting To</mat-label>
            <mat-select formControlName="users" multiple>
                <mat-option *ngFor="let user of users;" [value]="user?.id | numberToStringConvert">
                    <span>{{user?.name}}</span>
                </mat-option>
            </mat-select>
            <mat-error *ngIf="userFormValidate?.users?.errors?.required">This field is required.</mat-error>
        </mat-form-field> -->

        <div class="forReportTo">
            <mat-label>Reporting To</mat-label>
            <input type="hidden" formControlName="users">
            <ng-multiselect-dropdown [data]="users" [formControl]="userForm.controls['users']" [settings]="dropdownSettings">
            </ng-multiselect-dropdown>
            <mat-error *ngIf="userFormValidate?.users?.errors?.required">This field is required.</mat-error>
        </div>

        <div class="side-by-side-mat-form-field">
            <mat-form-field>
                <mat-label>Shift Week Start</mat-label>
                <mat-select formControlName="shift_week_starts">
                    <mat-option *ngFor="let shiftWeek of  shiftWeeks;" [value]="shiftWeek?.id">{{shiftWeek?.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="userFormValidate?.shift_week_starts?.errors?.required">This field is required.</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Shift Week End</mat-label>
                <mat-select formControlName="shift_week_ends">
                    <mat-option *ngFor="let shiftWeek of  shiftWeeks;" [value]="shiftWeek?.id">{{shiftWeek?.name}}</mat-option>
                </mat-select>
                <mat-error *ngIf="userFormValidate?.shift_week_ends?.errors?.required">This field is required.</mat-error>
            </mat-form-field>
        </div>
        <div class="side-by-side-mat-form-field">

            <mat-form-field>
                <mat-label>Shift time start at</mat-label>
                <input formControlName="shift_time_starts_at" [ngxTimepicker]="shift_time_starts_at_ref" matInput [ngxTimepicker]="fullTime" [format]="24">
                <ngx-material-timepicker #shift_time_starts_at_ref></ngx-material-timepicker>
                <mat-error *ngIf="userFormValidate?.shift_time_starts_at?.errors?.required">This field is required.</mat-error>
            </mat-form-field>

            <mat-form-field>
                <mat-label>Shift time end at</mat-label>
                <input formControlName="shift_time_ends_at" [ngxTimepicker]="shift_time_ends_at_ref" matInput [ngxTimepicker]="fullTime" [format]="24">
                <ngx-material-timepicker #shift_time_ends_at_ref></ngx-material-timepicker>
                <mat-error *ngIf="userFormValidate?.shift_time_ends_at?.errors?.required">This field is required.</mat-error>
            </mat-form-field>
        </div>

        <div class="footer-block text-center">
            <div class="button-group">
                <button type="submit" mat-raised-button class="btn-int-blue"> {{btnText}} </button>
            </div>
        </div>
    </form>
</div>